export const orderTypes = [
  {
    id: 'date,dsc',
    name: 'Sắp xếp theo năm xuất bản',
  },
  {
    id: 'title,asc',
    name: 'Sắp xếp theo nhan đề',
  },
  {
    id: 'date,asc',
    name: 'Sắp xếp theo tác giả',
  },
  {
    id: 'date_publication,asc',
    name: 'Sắp xếp theo năm xuất bản (tăng)',
  },
  {
    id: 'date_publication,dsc',
    name: 'Sắp xếp theo năm xuất bản (giảm)',
  },
];

export const defaultSearchField = {
  Completeness: '',
  Field: '',
  Operator: '',
  Position: '',
  Relation: '',
  SortType: '',
  Structure: '',
  Truncate: '',
  Value: '',
};

export const OPERATOR = {
  and: 'and',
  or: 'or',
  not: 'not',
};

export const OPERATOR_LIST = [
  {
    id: OPERATOR.and,
    name: 'Và',
  },
  {
    id: OPERATOR.or,
    name: 'Hoặc',
  },
  {
    id: OPERATOR.not,
    name: 'Loại bỏ',
  },
];

export const STRUCTURE = {
  phrase: 'phrase',
  wordList: 'word_list',
};

export const STRUCTURE_LIST = [
  {
    id: STRUCTURE.phrase,
    name: 'Chính xác',
  },
  {
    id: STRUCTURE.wordList,
    name: 'Gần giống',
  },
];

export const FIELD_LIST = window.FillBookSearchFieldsReact ? window.FillBookSearchFieldsReact() : [];

export const PAGE_SIZE = 24;

export const DEFAULT_CONDITION = {
  ...defaultSearchField,
  Operator: '',
  Value: '',
  Structure: STRUCTURE.phrase,
  Field: 'any',
};

export const VIEW_MODES = {
  grid: 'grid',
  list: 'list',
};
